/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * This file contains the invitation page component
 * ---------------------------------------------------------------------------------
 */

/*
 * ----------------------------------------------------------------------------------
 * Imports - External
 * ----------------------------------------------------------------------------------
 */

/**
 * Required to use React components.
 */

import Icon from '@/components/layouts/Icon/Icon';
import { Box, ButtonBase, darken, lighten, styled } from '@mui/material';
import * as React from 'react';

/*
 * ----------------------------------------------------------------------------------
 * Imports - Internal
 * ----------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */



const SideTile = styled(ButtonBase)(({ theme }) => ({
    flex: '1 1 auto',
    display: 'block',
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.mode === 'dark' ? undefined : theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    
    minWidth: 'calc(50% - 8px)',
    maxWidth: 'calc(50% - 8px)',

    

    [`${theme.breakpoints.up('sm')}`]: {
        minWidth: 'calc(33.33334% - 12px)',
        maxWidth: 'calc(33.33334% - 12px)',
    },

    [`${theme.breakpoints.up('md')}`]: {
        minWidth: 'unset',
        maxWidth: 'unset',
    },

}))

const IconArea = styled(Box, { shouldForwardProp: (propName) => propName !== 'color' })(({ theme, color }) => {
    let selectedColor: string = (theme.palette as any)[color as any]?.main;

    if (!selectedColor) {
        selectedColor = color as any;
    }

    return ({
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        padding: theme.spacing(0, 1),
        background: theme.palette.mode === 'dark' ? darken(selectedColor,0.7) : lighten(selectedColor, 0.7),
        color: theme.palette.mode === 'dark' ? darken(selectedColor,0.2) : lighten(selectedColor, 0.2),
        fontSize: '3rem',
        textAlign: 'center'
    })
})

const TextArea = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    textAlign: 'center'
}))

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */


interface ISidebarTile {
    name: string | undefined;
    iconPrefix: string | undefined;
    iconName: string | undefined;
    link: string | undefined;
    LinkNewTab: boolean | undefined;
    color: string | undefined;
}

const SidebarTile: React.FunctionComponent<ISidebarTile> = ({
    name,
    iconPrefix,
    iconName,
    link,
    LinkNewTab,
    color
}) => {


    return (
        
        <SideTile
            //@ts-ignore
            component="a"
            href={link}
            target={LinkNewTab === true ? '_blank' : '_self'}
        >
            <IconArea
                color={color}
            >
                <Icon icon={{ prefix: iconPrefix as any, iconName: iconName as any }} />
            </IconArea>
            <TextArea>
                {name}
            </TextArea>
        </SideTile>
        
    );
};

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */
export default SidebarTile;